export default function isPaymentValidated(cardInformation: CardInformation = {}, paypalId?: null | string): boolean {
    return Boolean(cardInformation.id || paypalId);
}
